import React, { useEffect, useState } from 'react';

import '../../styles/navbar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCaretDown, faHome, faNewspaper, faSearch, faCog, faSignOutAlt, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch, connect } from 'react-redux';
import { hideDropDownMenu } from '../../redux/actions/dropdownMenuActions';
import fmplogo from '../../assets/FMP-Icon.png'
import { LogOutAuthAction } from '../../redux/actions/AuthAction';
import { useHistory, withRouter  } from 'react-router-dom';
import { setRowsDataSelectedIndexState, fetchInvoices } from '../../redux/actions/PostActions';

function MainNavbar(props) {
    
    const dispatch = useDispatch();
    let history = useHistory();
    const { login_check, chosenDropdownMenuState, dropdownMenu } = props;

    return (        


        <div className="mainNavbarClass">

            <ShowSideBarMenu />
            
            <div className="navbarProfile">
                <div className="navbar-nav navbarProfile-logout">
                    <button className="nav-link" onClick={ () => {
                            dispatch(LogOutAuthAction(history));}}>
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faSignOutAlt} />
                        </div>
                        <div className="menuBtnDesc">
                            Logout
                        </div>                 
                    </button>                    
                </div>                                        
            </div>
        </div>
    );
}
    
function ShowSideBarMenu() {

    const history = useHistory();
    const dispatch = useDispatch();
    const [ show, setShow ] = useState(false);

    const chosenDropdownMenuState = useSelector(state => state.chosenDropdownMenuReducer);
    const authreducerState = useSelector(state => state.authreducer);
    
    let BatteryProgramSubMenuDisplay = BatteryProgramSubMenu;

    useEffect( () => { 
        setShow(true);        
        if(chosenDropdownMenuState !== undefined && chosenDropdownMenuState['hiddenDropdownList']['BATTERY_PROGRAM'] === 'HIDE'){
            setShow(false);
        }
    }, [chosenDropdownMenuState]);
    
    return (

        <nav className="navbar">           

            <ul className="navbar-nav-logo">
             
                <li className="topBarLogo fmp-logo">                        
                    <a href="/">
                        <img src={fmplogo} width="115px" alt="Factory Motor Parts" border="0"/>
                    </a>                                            
                </li>  
             </ul>

            <ul className="navbar-nav">             

                <li className="nav-item">
                    <button 
                        className="nav-link"
                        onClick={ () => {  
                            //history.push('/');
                            window.location.href='/'
                            //dispatch(fetchTransfers(authreducerState.user) )

                        } }>                         
                    
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faHome} />
                        </div>
                        <div className="menuBtnDesc">
                            Home
                        </div>
                        
                    </button>
                </li>
                
                <li className="nav-item">
                    <button 
                        className="nav-link"
                        onClick={ () => {  
                            history.push("/invoices");  
                            if(window.location.href.split("/").pop() === 'invoices'){                                
                                dispatch(fetchInvoices(authreducerState.user) )
                                dispatch(setRowsDataSelectedIndexState([]));
                            }
                            
                            // window.location.href='/invoices'
                        } }>                         
                    
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faFileInvoice} />
                        </div>
                        <div className="menuBtnDesc">
                            Invoices
                        </div>
                        
                    </button>
                </li>

                {/* <Can I='view' on='Proposal' > 
                    <li className="nav-item">
                        {console.log("MainNavbar Proposal ")}
                        
                        <button 
                            className="nav-link"
                            type="button" 
                            onClick={ () => { 
                                window.location.href='/consignments'; 
                            }} 
                        >                                                              
                            <div className="menuBtnDesc">
                                Consignments
                            </div>                        
                        </button>
                        
                    </li>
                </Can> */}
                
                {authreducerState.user.role_name !== undefined && authreducerState.user.role_name !== 'ADMIN' ? ( <React.Fragment></React.Fragment> ) : (
                    <li className="nav-item">
                        <button 
                            className="nav-link" 
                            type="button" 
                            onClick={ () => { 
                                window.location.href='/battery';
                            }}
                        >                                        
                            <div className="menuBtnImage">
                                <FontAwesomeIcon icon={faCaretDown} />
                            </div>
                            <div className="menuBtnDesc">
                                Battery Program
                            </div>                        
                        </button>                    
                        {show ? <BatteryProgramSubMenuDisplay/> : (<div></div>)}
                    </li>
                 )}

                {/* <li className="nav-item">
                    <button 
                        className="nav-link"
                        onClick={ () => { 
                           // dispatch(hideDropDownMenu("OPERATIONS"));                                                             
                        }} >                                                              
                        <div className="menuBtnImage">
                            <FontAwesomeIcon icon={faCaretDown} />
                        </div>
                        <div className="menuBtnDesc">
                            Operations
                        </div>                        
                    </button>
                </li> */}
                
            </ul>
        </nav>
    );
}


const routeChange_batteryCorporate = (history) =>{ 
    let path = `/battery/corporate`; 
    history.push(path);
  }

const BatteryProgramSubMenu = () => {
    const history = useHistory();
    return (
        <ul className="navbar-nav navbar-subNav batteryProgramCN">
            <li className="nav-item">
                <button 
                className="nav-link" 
                onClick={ () => {
                    routeChange_batteryCorporate(history)
                }} >  
                    <div className="menuBtnImage">
                        <FontAwesomeIcon icon={faNewspaper} />
                    </div>
                    <div className="menuBtnDesc">
                        Corporate
                    </div> 
                </button>                               
            </li>
        </ul>
    )
}



const mapStateToProps = (state) => {   
    return {
        chosenDropdownMenuState: state.chosenDropdownMenuReducer,
        // posts: state.posts,
        // authreducer: state.authreducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        // fetch_transfers: (user) => {
        //     dispatch(fetchTransfers(user));
        // },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainNavbar);